export default __webpack_public_path__ + "07baed76e3037fc86530baaa65f6872f.svg";